import React, { useState, useEffect, useContext } from 'react';
import { FaUserCircle, FaMusic, FaEye, FaEyeSlash } from 'react-icons/fa';
import Header from "../components/Header";
import { Link } from 'react-router-dom'
import { AuthContext } from "../context/AuthContext";
import { Button } from "../components/custom_ui/button.tsx";
import { useAlert } from '../context/AlertContext';

const AdminLoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const authContext = useContext(AuthContext);
  const { authLoading } = useContext(AuthContext);  // Correctly access getApplicationData from DataContext
  const [formData, setFormData] = useState({});
  const { showAlert } = useAlert();

  const handleFieldChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));

    console.log("Form Data:", formData);
  };


  const handleLogin = (e) => {
    e.preventDefault();
    const { username, password } = formData;
    let errors = [];
    if (!username || !password) {
      showAlert("All Fields are Required.", "danger");
      
      return;
    }

    if (!username.trim()) errors.push({ "type": "error", "message": "Username is required." });

    if (!password.trim()) errors.push({ "type": "error", "message": "Password is required." });
    else if (password.trim().length < 5) errors.push({ "type": "error", "message": "Password must be at least 5 characters." });

    if (errors.length > 0) {
      console.log("Errors ", errors);
      showAlert(errors[0].message, "danger");
      return;
    }
    authContext.admin_login(username, password);
  }

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="flex items-center justify-center p-4">
        <div className="bg-[#1D1D30] p-8 rounded-xl shadow-lg w-full max-w-md">

          <div className="flex flex-col items-center mb-6">
            <FaUserCircle className="text-7xl text-gold" />
            <h1 className="text-3xl font-bold text-white mt-4">Admin Portal</h1>
            <p className="text-gray-400">Track your music performance</p>
            <div className="flex items-center space-x-2 mt-2">
              <FaMusic className="text-gold" />
              <span className="font-semibold text-white">Music Analytics</span>
            </div>
          </div>

          <form>
            <div className="mb-4">
              <label className="block text-gray-400 text-sm mb-2" htmlFor="username">
                Username
              </label>
              <input
                className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-gold"
                id="username"
                type="text"
                value={formData.username || ''}
                onChange={(e) => handleFieldChange('username', e.target.value)}
                placeholder="Enter your username"
              />
            </div>

            <div className="mb-6">
              <label className="block text-gray-400 text-sm mb-2" htmlFor="password">
                Password
              </label>
              <div className="relative">
                <input
                  className="w-full bg-[#2A2A40] border border-gray-600 text-white rounded-md py-2 px-3 focus:outline-none focus:border-gold"
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  value={formData.password || ''}
                  onChange={(e) => handleFieldChange('password', e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
            </div>

            <Button
              className="w-full bg-gradient-to-r from-purple-600 to-blue-500 text-white font-bold py-3 px-4 rounded-md hover:from-purple-700 hover:to-blue-600 transition duration-200"
              type="submit"
              onClick={handleLogin}
              disabled={authLoading}
            >
              {authLoading ? <div className="spinner"></div> : "Sign In"}
            </Button>
          </form>

        
        </div>
      </div>
    </div>
  );
};

export default AdminLoginPage;